<template>
<div class="container-reclef">
    <TopoSlot class="printNone"></TopoSlot>
      
    <p style="color: #000;font-size:25px;font-weight:700;margin: 65px 50px 25px 50px;" class="printNone">Soma do valor simulado a ser compensado ou restituído.</p>  
    <div class="resultado">
        <p class="total">{{$store.state.resultado.totalGeralOriginal}}</p>
        <p class="totalRe">Correção de valor pela Selic: {{$store.state.resultado.totalGeralReajustado}}</p>
        <div v-if="$store.state.resultado.totalICMSSTRetMultiplicado && $store.state.mostrarCalculoAgregado" class="total-agregado" style="margin-top: 20px; border-top: 2px solid #af3437; padding-top: 20px; width: 60%; text-align: center;">
            <p style="font-size: 18px; font-weight: 600; color: #333; margin: 0;">Valor Total de ST Apurado (Agregado):</p>
            <p style="color: rgb(175, 52, 55); font-size: 30px; font-weight: bold; margin-top: 5px;">
                {{$store.state.resultado.totalICMSSTRetMultiplicado}}
            </p>
        </div>
        <div v-if="$store.state.tipoDeAnalise === 'difal'" class="total-agregado" style="margin-top: 20px; border-top: 2px solid #af3437; padding-top: 20px; width: 60%; text-align: center;">
            <h3 style="font-size: 18px; font-weight: 600; color: #333; margin: 0; text-transform: uppercase;">Resultado do DIFAL</h3>
            <div style="margin-top: 15px;">
                <p style="font-size: 16px; margin: 0;">Total FCP UF Destino:</p>
                <p style="color: rgb(175, 52, 55); font-size: 28px; font-weight: bold; margin-top: 5px;">
                    {{$store.state.resultado.totalFCPUFDestMultiplicado}}
                </p>
            </div>
            <div style="margin-top: 15px;">
                <p style="font-size: 16px; margin: 0;">Total ICMS UF Destino:</p>
                <p style="color: rgb(175, 52, 55); font-size: 28px; font-weight: bold; margin-top: 5px;">
                    {{$store.state.resultado.totalICMSUFDestMultiplicado}}
                </p>
            </div>
        </div>
        <button class="erro" @click="mostraErro" v-if="contadorErro >=1"><i class=" fas fa-exclamation-triangle" style="font-size: 20px;color:#fff;margin-right: 15px;"></i>{{contadorErro}} XMLs não recuperáveis</button>
        <div class="nota" style="max-width: 1000px;"><p><span style="color: rgb(54, 121, 149);">NOTA:</span> A atualização monetária dos valores de PIS e COFINS utilizou a taxa referencial do Sistema Especial de Liquidação e de Custódia - SELIC, nos termos do art. 39 da Lei 9.250/95 e a IN 1717/2017, art. 142.</p></div>
        <div v-if="$store.state.resultado.anos.length>=1" style="margin: 30px 0px; border-bottom: 1px solid rgb(175, 52, 55); width: 80%;"></div>
        <p class="text_selecionada" v-if="$store.state.resultado.anos.length>=1">Selecione o ano para analisar detalhadamente.</p>
        <div class="resultado-anos" v-if="$store.state.resultado.anos.length>=1">
            <div :class="{'resultado-ano':true, 'ano-toggle': n.ano == anoAtual}" v-for="(n,i) in lista" :key="i" @click="changeAno(n.ano)">{{n.ano}}</div>
        </div>
    </div>
    <div class="divPrint"  v-if="$store.state.resultado.anos.length>=1">
         <div style="height: 100%; display: flex; flex-direction: row; justify-content: space-around; align-items: center; margin: 0px 20px 0px 0px;" v-if="exibirTable.meses[mesAtual-1].dados.documentos.length>24">
             <div class="custom-control custom-checkbox">
                 <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" id="BVID5" @click="mostraTudo">
                 <label class="custom-control-label" for="BVID5">
                     </label>
                     </div>
                    <p style="margin: 0px; font-size: 14px; font-weight: 400;line-height: 24px;color: #7e7e7e;">Mostrar todos</p>
                    </div>
                    <img src="/reclef/print.svg" alt="" @click="imprimir" width="65px" style="cursor: pointer;" >
    </div> 
    <modal name="ok" width="80%" height="100%"> 
               <div class="errosDiv">
                   <div style="width: 100%; height: 88%;padding-bottom: 13px;"
                   ><div style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 10px;">
                       <p style="margin: 0px; text-align: center; font-size: 20px; color: rgb(112, 112, 112); font-weight: bold;">Verificação XMLs com erros | {{$store.state.resultado.erros.contador}} <span style="font-weight: 400;">documentos no total</span>
                       </p>
                       <i class="fas fa-times" style="cursor: pointer; font-size: 20px; margin-right: 10px;" @click="$modal.hide('ok')"></i>
                    </div>
                <div class="b-table-sticky-header table-responsive" style="height:98%">
                    <table role="table" aria-busy="false" aria-colcount="3" class="table b-table tableClass" id="__BVID__1024">
                        <thead role="rowgroup" class="errosTableThead">
                            <tr role="row" class="">
                                <th role="columnheader" scope="col" aria-colindex="1" class="table-b-table-default">Arquivo</th>
                                <th role="columnheader" scope="col" aria-colindex="1" class="table-b-table-default">Chave Acesso</th>
                                <th role="columnheader" scope="col" aria-colindex="2" class="table-b-table-default">Cnpj</th>
                                <th role="columnheader" scope="col" aria-colindex="3" class="table-b-table-default">Motivo</th>
                            </tr>
                        </thead>
                        <tbody role="rowgroup" class="errosTableTbody">
                            <tr role="row" class="" v-for="(n,i) in $store.state.resultado.erros.lstErros" :key="i">
                                <td aria-colindex="1" role="cell" class="">{{!n.arquivo ? '-' : n.arquivo}}</td>
                                <td aria-colindex="1" role="cell" class="">{{!n.chaveAcesso ? '-' : n.chaveAcesso}}</td>
                                <td aria-colindex="2" role="cell" class="">{{!n.cnpj ? '-' : n.cnpj}}</td>
                                <td aria-colindex="3" role="cell" class="">{{!n.motivo ? '-' : n.motivo}}</td>
                            </tr>                            
                            </tbody>
                    </table>
                </div>
            </div>
            <button style="width: 100%; max-width: 130px;  height: 40px;background: #af3437; color: #fff; font-size: 15px; font-weight: 700;margin-top:20px;" @click="$modal.hide('ok')">Voltar</button></div>
        
    </modal> 
    
    <div class="printN" v-if="$store.state.resultado.anos.length>=1">
        <div class="header">
            <img src="https://www.lefisc.com.br/monitoramentoncm/img/logo.png" :style="{'width': '115px', 'height': '27px;'}">
       <img :style="{'filter':'saturate(500%) contrast(800%) brightness(500%) invert(80%) sepia(50%) hue-rotate(120deg)'}" src="https://www.lefisc.com.br/reclef/img/Revisor da Exclusão do ICMS do PISCOFINS_Prancheta 1.png" alt="reclef" >
    </div>
    <br>
    <br>
        <div class="nota" style="max-width: 1000px;border:none;font-size:20px;"><p><span style="color: rgb(54, 121, 149);">NOTA:</span> A atualização monetária dos valores de PIS e COFINS utilizou a taxa referencial do Sistema Especial de Liquidação e de Custódia - SELIC, nos termos do art. 39 da Lei 9.250/95 e a IN 1717/2017, art. 142.</p></div>
        <div style="font-size:32px;font-weight:600;margin:40px 0px;display: flex;align-items: center;justify-content: space-between;">
            <span>CNPJ:{{cnpj}}</span> <span style="margin:0px 20px;">Mês: {{exibirTable.meses[mesAtual-1].nome}}</span><span>Ano: {{anoAtual}}</span>
        </div>
        <br>
    </div>      
    <div style="padding: 10px;" v-if="$store.state.resultado.anos.length>=1">
    <div class="resultado-notas">
        <div v-for="(n,i) in exibirTable.meses" :key="i" v-show="!!n.dados.mes" style="width:100%;max-width: 250px;" @click="changeMes(n.id,i)">       
                    <div :class="{'mes':true,'mes-toggle':n.id == mesAtual}">
                        {{n.nome}} 
                    </div>
        </div>
    </div>   
    
    <table id="tableResultado" class="styled-table">
    <thead>
        <tr>
            <th>Data</th>
            <th v-show="$store.state.tipoDocumento == 1">Produto</th>
            <th>Chave de acesso</th>
            <th v-show="$store.state.tipoDocumento == 1">NCM</th>
            <th>PIS a recuperar</th>
            <th>COFINS a recuperar</th>
            <th>PIS reajustado</th>
            <th>COFINS reajustado</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(n,i) in lists" :key="i">
            <td>
                {{n.data}}
            </td>
             <td v-show="$store.state.tipoDocumento == 1">
                {{n.produto}}
            </td>
            <td>
                {{n.chaveAcesso}}
            </td>
             <td v-show="$store.state.tipoDocumento == 1">
                {{n.ncm}}
            </td>
            <td>
                {{n.aliquotaOriginal.pis}}
            </td>
             <td>
                {{n.aliquotaOriginal.cofins}}
            </td>
            <td>
                {{n.aliquotaReajustada.pis}}
            </td>
             <td>
                {{n.aliquotaReajustada.cofins}}
            </td>
        </tr>
         <tr>
            <td>
            
            </td>
            <td v-show="$store.state.tipoDocumento == 1">

            </td>
            <td v-show="$store.state.tipoDocumento == 1">
                
            </td>
            <td style="text-align: right;">
             Totais:
            </td>
            <td>
             {{exibirTable.meses[mesAtual-1].dados.totalOriginal.pis}}
            </td>
             <td>
                {{exibirTable.meses[mesAtual-1].dados.totalOriginal.cofins}}
            </td>
            <td>
                {{exibirTable.meses[mesAtual-1].dados.totalReajustado.pis}}
            </td>
             <td>
                 {{exibirTable.meses[mesAtual-1].dados.totalReajustado.cofins}}
            </td>
        </tr>
    </tbody>
    </table>
     <div class="pagi" style="display:flex;justify-content: center;margin-top:50px;">
              <b-pagination
                v-model="currentPage"
                :total-rows="exibirTable.meses[mesAtual-1].dados.documentos.length"
                :per-page="perPage"
                aria-controls="my-table"
                @input="myClickedEventhandler(currentPage)"
              ></b-pagination>
            </div>
    </div>

    <div>
        <button @click="voltarPagina()" style="width: 100%; max-width: 130px;  height: 40px;background: #af3437; color: #fff; font-size: 15px; font-weight: 700;margin-top:20px; margin-bottom: 20px; border-radius: 5px;">Voltar</button>
    </div>
  
</div>
</template>

<script>
import {Ano} from '../services/Ano'
export default {
    data(){
        return{
            cnpj:'',
            perPage:25,
            currentPage:1,
            lista: [],
            mesAtual:'',
            anoAtual:0,
            contadorErro:0,
            exibirTable:[],
            exibirMaisQueDez:true,
            count:25,         

        }
    },
    computed:{        
            lists(){            
                return this.exibirTable.meses[this.mesAtual-1].dados.documentos.slice(
                    (this.currentPage - 1)  * this.perPage, this.currentPage * this.perPage)
            },
            documentos(){     
                return this.exibirTable.meses[this.mesAtual-1].dados.documentos.filter((val,i)=>i<this.count)
            }              
    },
    methods:{
        voltarPagina (){
            this.$router.push({ name: 'importar' })
        },
        imprimir(){
            window.print()
        },
        mostraErro(){
            this.$modal.show('ok')
        },
        mostraTudo(){
            if(this.perPage == 25){
                this.perPage = this.exibirTable.meses[this.mesAtual-1].dados.documentos.length
            }else{
                this.perPage = 25
            }
        },
        changeMes(mes){    
            this.perPage = 25
            this.mesAtual = mes
            document.getElementById('BVID5').checked = false
        },
        changeAno(ano){
            this.perPage = 25
            this.anoAtual =  ano
            this.exibirTable = this.lista.find(e=>e.ano == ano)
            this.mesAtual =  this.exibirTable.meses.find(e=> !!e.dados.mes).id
            document.getElementById('BVID5').checked = false
        },
        organizar(){     
            this.cnpj = this.$store.state.resultado.cnpj
            this.perPage = 25   
            this.contadorErro = this.$store.state.resultado.erros.contador
            if( this.$store.state.resultado.anos.length>=1){
            this.$store.state.resultado.anos.forEach(ano => {                   
                let anoA = new Ano()
                anoA.ano  = ano.ano
                ano.meses.forEach(mes => {anoA.meses[mes.mes-1].dados = mes})
                this.lista.push(anoA)
            });
           this.lista =  this.lista.sort(function(a,b) {
                return a.ano < b.ano ? -1 : a.ano > b.ano ? 1 : 0;
            });
            this.anoAtual = this.lista[0].ano 
            this.changeAno(this.anoAtual)
            }
        }
    },
    mounted(){
        this.organizar()
    }
    
}
</script>

<style>
.dropdown-item:focus{
    background:#af3437;
}
.dropdown-item:hover{
        background: #ffc5c6;
}
.printN{
    display: none;
}
@media print {
    body{
        background:#fff !important;
    }
    #app{
        min-height: 300px !important;
    }
    .container-reclef{
  min-height: 80vh !important;
    }
    .printN{
    display: block;
}
    .printNone{
         display: none !important;
    }
    .resultado-notas{
          display: none !important;
    }
    .rodape{
        display: none !important;
    }
    #navba{
        display: none !important;
    }
  .divPrint{
  display: none !important;
  }
  .pagi{
         display: none !important;
  }
  .resultado{
      display: none !important;
  }
}
button:focus{
    outline: none !important;
}
a:focus{
     outline: none !important;
}
.errosTableThead tr th {
    background: #af3437!important;
    color: #fff!important;
    text-align: center!important;
}
.errosTableTbody  tr {
  font-size: .8em;
    background: #ffffff;
}
.errosTableTbody tr:nth-of-type(2n) {
    background-color: #ffc5c6;
}
.page-item.active .page-link, .page-item:hover .page-link {
    background: #af3437!important;
    border: 1px solid #af3437!important;
    color:#fff !important;
}
.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.b-pagination-pills .page-item .page-link {
    border-radius: 50rem!important;
    margin-left: 0.25rem;
    line-height: 1;
}
.b-pagination-pills .page-item .page-link {
    border-radius: 50rem!important;
    margin-left: 0.25rem;
    line-height: 1;
}
.page-item .page-link {
    color: #af3437;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
}
.page-item .page-link {
    color: #af3437;
}
.pagination {   
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
}
.divPrint{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.mes-toggle{
    background: #af3437 !important;
    color:#fff  !important;
}
.styled-table td, .styled-table th {
    padding: 12px 15px;
    text-align: center;
}
div.changeAnoBa{
    background: #af3437!important;
    color: #fff;
}
.styled-table tbody tr {
    border-bottom: 1px solid #ddd;
    max-height: 50px;
    background: #ffffff;
}
.styled-table tbody tr:nth-of-type(2n) {
    background-color: #ffc5c6;
}
.styled-table{
border-collapse: collapse;
    font-size: .78em;
    font-family: sans-serif;
    width: 100%;
    overflow: scroll;
    -webkit-box-shadow: 0 0 20px rgb(0 0 0 / 15%);
    box-shadow: 0 0 20px rgb(0 0 0 / 15%);
}
.styled-table tbody tr:last-of-type {
    border-bottom: 2px solid #af3437;
}
.styled-table tbody tr:last-child {
    background-color: #af3437;
    color: #fff;
    font-weight: 600;
}
.styled-table thead tr {
    background-color: #af3437;
    color: #fff;
    text-align: left;
}
th {
        color: #fff;
    padding: 12px 15px;
    text-align: center;
}
thead {
    display: table-header-group;
}
.ano-toggle {
    background: #af3437;
    color: #fff !important;  
}
.resultado-anos{
   margin: 30px 0 100px 0;
    width: 65%; 
    display: flex;
    flex-direction: row;
    justify-content: space-around; 
    align-items: center;
    color:#fff;
}
.resultado-ano{
    cursor: pointer;
    margin: 0 10px;
    text-align: center;
    max-width: 155px;
    width: 100%;
    height: 50px;
    border: 4px solid #af3437;
    border-radius: 7px;
    font-size: 25px;
    font-weight: 700;
    display: flex;    
    justify-content: space-around; 
    align-items: center;
    color: #212529;
}
.text_selecionada{
    margin: 20px 0;
    font-size: 30px;
    color: #000;
}
.resultado-notas  .mes{
    max-width: 250px;
    cursor: pointer;
    width: 100%;
    height: 36px;
    display: flex;   
    justify-content: center;   
    align-items: center;
    background: #fff;
    color: #af3437;
    border: 2px solid #af3437;
    border-radius: 10px 10px 0 0;
    font-weight: 700;
    font-size: 14px;

}
.resultado-notas{
    width: 100%;
    display: flex;
}
.resultado {
    display: flex;
    flex-direction: column;
    align-items: center;
}
button.erro{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;
    height: 50px;
    background: rgb(175, 52, 55);
    color: rgb(255, 255, 255);
    border-radius: 5px;
    margin: 15px 15px 35px;
    font-size: 18px;
    font-weight: bold;
}
.total{
    color: rgb(175, 52, 55);
    font-size: 55px;
        margin-bottom: 0;
}
.totalRe{
        font-size: 22px;
    
    font-weight: bold;
}
</style>